// extracted by mini-css-extract-plugin
module.exports = {"box":"box-18IOROxd","ad_box":"ad_box-170uiJCI clearfix","fl":"fl-11hywVDh fl","fr":"fr-3DBrToGP fr"};